import type { GetServerSideProps } from "next";
import config from "../utils/env";

function generateRobots(domain: string) {
  if (config.DISALLOW_ROBOTS) {
    return `User-agent: *
Disallow: /`;
  }
  // Else, we allow robots, and point them to the sitemap.
  return `User-agent: *
Allow: /

Sitemap: https://${domain}/sitemap_index.xml
 `;
}

function Robots() {
  // getServerSideProps will do the heavy lifting
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  locale = "en-us",
  ...rest
}) => {
  const domain = req.headers.host;
  console.log("ssp", { rest });
  if (typeof domain !== "string") {
    throw new Error(`Invalid domain: ${req.headers.host}`);
  }
  const robotContent = generateRobots(domain);
  console.log(locale);
  res.setHeader("Content-Type", "text/plain");
  res.write(robotContent);
  res.end();
  return {
    props: {},
  };
};

export default Robots;
